/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".placeholder-wrapper[_ngcontent-%COMP%]{position:relative;min-height:300px}.placeholder-wrapper[_ngcontent-%COMP%]   .full-placeholder[_ngcontent-%COMP%]{position:fixed;top:0;left:0;width:100%;height:100%}.placeholder-wrapper[_ngcontent-%COMP%]   .full-placeholder[_ngcontent-%COMP%]     #spinner{background-color:rgba(241,241,241,.4)}.placeholder-wrapper[_ngcontent-%COMP%]   .partial-placeholder[_ngcontent-%COMP%]{position:absolute;top:0;left:0;display:block;width:100%;height:100%;min-height:300px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/core/achoo-placeholder/achoo-placeholder.component.scss.shim.ngstyle.js.pre-build-optimizer.js